import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialComponent } from './dial.component';
import { ChartModule } from 'angular-highcharts';

@NgModule({
  declarations: [DialComponent],
  imports: [CommonModule, ChartModule],
  exports: [DialComponent],
})
export class DialModule {}
